module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "all_app p_background clearfix",
    attrs: {
      "id": "manager_order_list"
    }
  }, [_c('h3', {
    staticClass: "all_title"
  }, [_vm._v("订单管理")]), _vm._v(" "), _c('section', {
    staticClass: "all_container container_box"
  }, [_c('div', {
    staticClass: "operation_box clearfix"
  }, [_c('section', {
    staticClass: "date pull-left"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "range-separator": "-",
      "format": "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd",
      "start-placeholder": "开始时间",
      "end-placeholder": "结束时间"
    },
    on: {
      "change": _vm.searchDaterange
    },
    model: {
      value: (_vm.dateScop),
      callback: function($$v) {
        _vm.dateScop = $$v
      },
      expression: "dateScop"
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "date_sort pull-left",
    on: {
      "click": _vm.dateSort
    }
  }, [_vm._v("\n\t\t\t\t\t时间\n\t\t\t\t\t"), _c('i', {
    staticClass: "glyphicon icon icon_down1"
  })]), _vm._v(" "), _c('section', {
    staticClass: "money_sort pull-left",
    on: {
      "click": _vm.moneySort
    }
  }, [_vm._v("\n\t\t\t\t\t金额\n\t\t\t\t\t"), _c('i', {
    staticClass: "glyphicon icon icon_down"
  })]), _vm._v(" "), _c('section', {
    staticClass: "look_type pull-left"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.appLevel),
      expression: "appLevel"
    }],
    staticClass: "select",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.appLevel = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.queryTCloudAppOrderListManager]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("查看全部类型")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("只看区级")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("只看校级")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "free"
    }
  }, [_vm._v("只看免费试用")])])]), _vm._v(" "), _c('section', {
    staticClass: "account_type pull-left"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payStatus),
      expression: "payStatus"
    }],
    staticClass: "select",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.payStatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.queryTCloudAppOrderListManager]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("查看到账情况")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "113002"
    }
  }, [_vm._v("已到账")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "113001"
    }
  }, [_vm._v("未到账")])])]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('section', {
    staticClass: "search_box border_color"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.condition),
      expression: "condition",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "search_control",
    attrs: {
      "type": "text",
      "placeholder": "输入应用名称/订单编号/购买者/支票号码"
    },
    domProps: {
      "value": (_vm.condition)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.queryTCloudAppOrderListManager.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.condition = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "glyphicon icon_search",
    on: {
      "click": _vm.queryTCloudAppOrderListManager
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "table_box clearfix"
  }, [_c('table', {
    staticClass: "table table-hover text-center"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.page.content), function(item, index) {
    return _c('tr', [_c('td', [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(item.orderNo) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', {
      staticClass: "line_block text-left"
    }, [_c('div', {
      staticClass: "apply_thumbnail"
    }, [_c('img', {
      staticClass: "img_default",
      attrs: {
        "src": item.filePath,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "text-left"
    }, [_c('p', [_vm._v(_vm._s(item.viewName))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.versionNo))])])]), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(item.chName) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_c('p', [_vm._v(_vm._s(item.schoolName))]), _vm._v(" "), (item.appLevel == 1 && item.userType == 101010) ? _c('p', {
      staticClass: "color_9"
    }, [_vm._v("区级购买（" + _vm._s(item.nums) + "套）")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("time")(item.orderTime)) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), (item.orderStatus != '114001') ? _c('td', [_c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(item.orderPrice) + "元人民币\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), (item.onecoverTime == 9999) ? _c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t无期限\n\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (item.durationOneset % 12 == 0) ? _c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(item.durationOneset / 12) + "年期限\n\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (item.durationOneset % 12 > 0) ? _c('p', [(item.durationOneset / 12 >= 1) ? _c('span', [_vm._v(_vm._s(_vm._f("fmtMoney")(item.durationOneset / 12)) + "年")]) : _vm._e(), _vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(item.durationOneset % 12) + "个月期限\n\t\t\t\t\t\t\t\t")]) : _vm._e()]) : _c('td', [_c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t免费试用（一个月）\n\t\t\t\t\t\t\t\t")])]), _vm._v(" "), (item.orderStatus != '114001') ? _c('td', [(item.payStatus == '113002') ? _c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t已到账\n\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (item.payStatus == '113001') ? _c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t未到账\n\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (item.chequeNo != null && item.payType == '140120') ? _c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t已付款\n\t\t\t\t\t\t\t\t\t"), _c('a', {
      staticClass: "glyphicon icon_cheque",
      attrs: {
        "target": "_blank",
        "href": item.chequepicPath
      }
    }, [_c('span', {
      staticClass: "text-space"
    }, [_c('small', [_vm._v("支票号码：" + _vm._s(item.chequeNo))]), _vm._v(" "), _c('small', [_vm._v("支票金额：" + _vm._s(item.chequeMoney))]), _vm._v(" "), _c('small', [_vm._v("支票说明：" + _vm._s(item.chequeComment))])])])]) : (item.payType != '140120' && item.payStatus == '113002') ? _c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t已付款\n\t\t\t\t\t\t\t\t")]) : _c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t未付款\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), (item.payStatus == '113002') ? _c('div', {
      staticClass: "margin_b4"
    }) : _vm._e(), _vm._v(" "), (item.payStatus == '113001' && item.chequeNo != null) ? _c('div', {
      staticClass: "margin_b4"
    }, [_c('button', {
      staticClass: "btn btn_border",
      attrs: {
        "id": "confirm_order"
      },
      on: {
        "click": function($event) {
          return _vm.confirmOrder(item.id, item.chequeId, item.userId, item.viewName)
        }
      }
    }, [_vm._v("确认到账")])]) : _vm._e()]) : _c('td', [_c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t实时开通\n\t\t\t\t\t\t\t\t")])]), _vm._v(" "), (item.orderStatus != '114001') ? _c('td', [(item.authStatus == '112002') ? _c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t已授权使用\n\t\t\t\t\t\t\t\t")]) : (item.authStatus == '112004') ? _c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t免费试用\n\t\t\t\t\t\t\t\t")]) : (item.authStatus == null || item.authStatus == '') ? _c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t未授权使用\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (item.authStatus == null || item.authStatus == '') ? _c('div', {
      staticClass: "margin_b4"
    }, [_c('button', {
      staticClass: "btn btn_border",
      attrs: {
        "id": "authorized_use"
      },
      on: {
        "click": function($event) {
          return _vm.toAuthUse(item.id)
        }
      }
    }, [_vm._v("授权使用")])]) : _vm._e()]) : _c('td', [_c('p', [_vm._v("剩余" + _vm._s(item.diffDays))])])])
  }), _vm._v(" "), (_vm.page.total <= 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v("暂无数据")])]) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "text-center",
    class: _vm.page.totalPages > 0 ? 'show' : 'hidden'
  }, [_c('div', {
    staticClass: "row-fluid"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [10, 20, 30, 40],
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.page.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)]), _vm._v(" "), _c('v-tip', {
    attrs: {
      "trueFlag": _vm.trueFlag,
      "falseFlag": _vm.falseFlag,
      "tipMsg": _vm.tipMsg
    }
  }), _vm._v(" "), (_vm.confirmFlag) ? _c('v-confirm', {
    attrs: {
      "bigMsg": _vm.bigMsg
    },
    on: {
      "confirmOff": function($event) {
        _vm.confirmFlag = !_vm.confirmFlag
      },
      "confirmTrue": function($event) {}
    }
  }) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "bounce",
      "mode": "out-in"
    }
  }, [(_vm.confirmFlag) ? _c('v-confirm', {
    attrs: {
      "bigMsg": "授权该应用?",
      "smallMsg": ""
    },
    on: {
      "confirmOff": function($event) {
        _vm.confirmFlag = !_vm.confirmFlag
      },
      "confirmTrue": _vm.toAuthUseConfirm
    }
  }) : _vm._e()], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("订单编号")]), _vm._v(" "), _c('th', [_vm._v("应用名称")]), _vm._v(" "), _c('th', [_vm._v("开发者")]), _vm._v(" "), _c('th', [_vm._v("购买者")]), _vm._v(" "), _c('th', [_vm._v("购买时间")]), _vm._v(" "), _c('th', [_vm._v("金额及类型")]), _vm._v(" "), _c('th', [_vm._v("是否到账及类型")]), _vm._v(" "), _c('th', [_vm._v("操作")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-4cda6aeb"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/order/manager_order_list.vue
// module id = 1255
// module chunks = 1